export const Roles = {
    ADMIN: "Admin",
    EDITOR: "Editor",
    CONSULTA: "Consulta"
};